import { render, staticRenderFns } from "./AppImgViewer.vue?vue&type=template&id=cc288608&"
import script from "./AppImgViewer.vue?vue&type=script&lang=js&"
export * from "./AppImgViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports